const imageFromSvg = ({ SVG }) => {
  const image = document.createElement("img");
  image.src = `data:image/svg+xml;base64,${btoa(SVG)}`;
  return image;
};
export {
  imageFromSvg
};
//# sourceMappingURL=imageFromSvg.js.map
